import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: 'a846387b-b1c9-4022-a1ff-493bfd9a151a',
    countryCodes: ['SE'],
    locale: 'sv-SE',
});
